
export default {
    emptyCategory: {
        title: 'No measurements in this category',
        subtitle: 'You can enable measurements from “{settings}”.'
    },
    tabs: {
        general: 'General notes',
        progress: 'Show measurement progress',
        body: 'Body measurements',
        dermatoptixes: 'Δερματοπτυχές',
        mezoures: 'Μεζούρες',
        vitamins: 'Vitamins',
        bloodGeneral: 'General Hematological',
        biochemicals: 'Biochemical',
        hormonological: 'Hormonological',
        bloodWork: 'Blood Work',
        extra: 'Extra (fat meters)'
    },
    settings: 'Measurement settings',
    printFatMeter: 'Fat meter Print',
    print: 'Print',
    printMeasurements: 'Print measurements',
    progress: 'View progress',
    massImport: 'Mass measurement import',
    add: 'Add measurements',
    date: 'Date of measurement',
    value: 'Value',
    general: {
        title: 'General notes',
        subtitle: 'Type notes about your customer\'s measurements to remember on your next appointment!'
    },
    fatMeter: {
        intro: 'Using this, you can import your measurements from your fat-meter exports (CSV file).',
        insert: 'Import measurements',
        closeWithoutSave: 'Close without saving',
        invalidCsv: 'The CSV you have uploaded is invalid.',
        noMeasurement: 'No measurement was found in this file. Check that it\'s the CSV you exported from your fat meter.',
        sections: {
            general: 'General',
            waterProtein: 'Water & Protein',
            muscleSegments: 'Muscle mass per segment',
            fatKgSegments: 'Fat per segment (kg)',
            fatPerSegments: 'Fat per segment (%)',
            phaseAngle: 'Phase angle (50kHz)',
            mezoures: 'Circumferences',
        }
    },
    printModal: {
        tabs: {
            base: 'Base information',
            options: 'Print options',
        },
        showDiagrams: 'Show diagrams',
        showText: 'Show text',
        progress: 'Client progress',
        filterByNumber: 'Number of measurements',
        filterByDateRange: 'Date range',
        limitAll: 'All',
        limitCustom: 'Custom',
        numberOfMeasurements: 'Number (last N)',
        lastMeasurements: 'Last {count}|Last {count}',
        newestMeasurementsNotice: 'Uses the newest (most recent) measurements.',
        dateFrom: 'From',
        dateTo: 'To'
    },
    printFatMeterModal: {
        missingHeight: 'Caution! You have not imported the <strong>height</strong> of your client.',
        missingWeight: 'Caution! You have not imported the <strong>weight</strong> of your client and results might be invalid',
        measurementDate: 'Measurement date',
        dateLatest: 'Latest',
        dateLatestWithDate: 'Latest ({date})',
        earlierMeasurementsWarningBefore: 'The measurements ',
        earlierMeasurementsWarningAfter: ' are from an earlier date; the data may not match the selected date.',
        earlierMeasurementsWarningBeforeSingular: 'The measurement ',
        earlierMeasurementsWarningAfterSingular: ' is from an earlier date; the data may not match the selected date.',
        hideEarlierMeasurements: 'Hide from print',
        information: 'INFORMATION',
        results: 'MEASUREMENT RESULTS',
        partialAnalysis: 'SEGMENTAL ANALYSIS',
        phaseAngleAnalysis: 'PHASE ANGLE (50kHz)',
        phaseAngleWholeBody: 'WHOLE BODY',
        phaseAngleSegments: 'SEGMENTAL',
        composition: 'BODY COMPOSITION',
        clothes: 'Clothes',
        result: 'Results',
        recommended: 'Target',
        normalRange: 'Desirable Range',
        muscles: 'Muscles',
        torso: 'TRUNK',
        ecwRatio: 'ECW Ratio',
        phaseAngle: 'Phase Angle',
        proteins: 'Protein',
        printLanguage: 'Print language',
        emailSubject: 'Fat Meter - {date}',
        emailContent: 'Please find attached the fat meter measurement results.'
    },
    progressCard:{
        title: 'Measurement progress',
        subtitle: 'See the aggregated progress of your client\'s measurements',
        info: 'Select measurements (you can only select the ones you have at least one measurement on)'
    },
    settingsIntro: ' <p>By changing these settings, you\'ll stop seeing the non-selected measurements (in all places applicable).' +
        ' <i>Note: Measurements will not be lost, only hidden!</i></p>',
    single: {
        edit: 'Edit measurement',
        progressNoEditable: 'This measurement was imported from the monitoring sheet and can\'t be edited here',
        choose: 'ΕΠΙΛΟΓΗ ΜΕΤΡΗΣΗΣ',
        history: 'Measurement history',
        diagram: 'Measurement diagram',
        add: 'Add measurement',
        empty: 'No measurements for “{name}”',
        emptySubtitle: 'Record your first measurement using the form below.',
        normalRange: 'Normal value range',
        notePlaceholder: 'Notes about this measurement',
        missingMeasurementLink: 'Missing a lab test / measurement type?',
        record: 'record | records'
    },
    skinfold: {
        title: 'Skinfold Analysis',
        button: 'Skinfold Analysis',
        tabEntry: 'Measurement & Results',
        protocol: 'Protocol',
        protocolJP3: 'Jackson-Pollock 3-site',
        protocolJP7: 'Jackson-Pollock 7-site',
        protocolDW4: 'Durnin-Womersley 4-site',
        protocolFAULKNER: 'Faulkner (1968)',
        protocolCARTER: 'Carter / Yuhasz',
        protocolISAK: 'ISAK (8-site)',
        measurementDate: 'Measurement date',
        dateLatest: 'Latest',
        dateLatestWithDate: 'Latest ({date})',
        weight: 'Weight (kg)',
        weightPlaceholder: 'Weight in kg',
        weightAutoFilled: 'Auto-filled from measurements',


        results: 'Results',
        bodyDensity: 'Body Density',
        fatPercent: 'Body Fat %',
        fatPercentSiri: 'Fat % (Siri)',
        fatPercentBrozek: 'Fat % (Brozek)',
        fatMass: 'Fat Mass',
        fatFreeMass: 'Fat-Free Mass',
        sumOfFolds: 'Sum of Skinfolds',
        category: 'Classification',
        allSites: 'All sites',
        newMeasurement: 'New measurement',
        save: 'Save measurements',
        selectProtocolForResults: 'Select a protocol to see results',
        duplicateDate: 'Some measurements already exist for this date and are pre-filled. You can add the missing ones.',
        duplicateDateLink: 'View all measurements for this date',
        missingSites: 'Fill in the required sites to calculate results',
        missingWeight: 'Enter weight to calculate fat/lean mass',
        noData: 'No skinfold data found for this date',
        diagramFront: 'Front',
        diagramBack: 'Back',
        viewAnalysis: 'Analysis',
        viewIndividual: 'Individual',
    }

}
